<template>
  <div>
    <img src="static/assets/images/149.jpg" style="width: 100%;height: 600px;"/>

    <!-- Pricing Table Starts -->
    <section class="pricing-table section-padding">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <h2>企业痛点</h2>
<!--              <p>gormless cheeky bugger he nicked it golly gosh a arse show off show off</p>-->
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="single-table text-center mb-4 mb-md-0">
              <div class="table-top">
                <h3>劳务成本高</h3>
                <i class="fa fa-plus-square"></i>
              </div>
              <ul class="my-5">
                <li class="mb-2">社保调整</li>
                <li class="mb-2">劳务成本高</li>
                <li class="mb-2">用工多元化</li>
                <li class="mb-2">成为企业大势所趋</li>
              </ul>
<!--              <a href="#" class="template-btn">Buy now</a>-->
            </div>
          </div>
          <div class="col-md-4">
            <div class="single-table text-center mb-4 mb-md-0">
              <div class="table-top">
                <h3>支出不入账，入账不报税</h3>
                <i class="fa fa-shield"></i>
              </div>
              <ul class="my-5">
                <li class="mb-2">支付失误率高</li>
                <li class="mb-2">面临严重处罚</li>
                <li class="mb-2">公转私支付风险高</li>
                <li class="mb-2">监管严批量支付效率低</li>
              </ul>
            </div>
          </div>
          <div class="col-md-4">
            <div class="single-table text-center">
              <div class="table-top">
                <h3>负税重</h3>
                <i class="fa fa-spinner"></i>
              </div>
              <ul class="my-5">
                <li class="mb-2">个人所得税过高</li>
                <li class="mb-2">企业所得税税负重</li>
                <li class="mb-2">企业利润大幅度减少</li>
                <li class="mb-2">竞争力逐步下降</li>
              </ul>
            </div>
          </div>
        </div>
<!--        <i class="fa fa-hdd-o"></i>-->
<!--        <i class="fa fa-bullhorn"></i>-->
<!--        <i class="fa fa-bell"></i>-->
<!--        <i class="fa fa-certificate"></i>-->
<!--        <i class="fa fa-hand-o-right"></i>-->
<!--        <i class="fa fa-hand-o-left"></i>-->
<!--        <i class="fa fa-hand-o-up"></i>-->
<!--        <i class="fa fa-hand-o-down"></i>-->
<!--        <i class="fa fa-arrow-circle-left"></i>-->
<!--        <i class="fa fa-arrow-circle-right"></i>-->
<!--        <i class="fa fa-arrow-circle-up"></i>-->
<!--        <i class="fa fa-arrow-circle-down"></i>-->
<!--        <i class="fa fa-globe"></i>-->
<!--        <i class="fa fa-wrench"></i>-->
<!--        <i class="fa fa-tasks"></i>-->
<!--        <i class="fa fa-filter"></i>-->
<!--        <i class="fa fa-briefcase"></i>-->
<!--        <i class="fa fa-arrows-alt"></i>-->
<!--        <i class="fa fa-group"></i>-->
<!--        <i class="fa fa-chain"></i>-->
<!--        <i class="fa fa-cloud"></i>-->
<!--        <i class="fa fa-flask"></i>-->
<!--        <i class="fa fa-paperclip"></i>-->
<!--        <i class="fa fa-save"></i>-->
<!--        <i class="fa fa-square"></i>-->
<!--        <i class="fa fa-navicon"></i>-->
<!--        <i class="fa fa-list-ul"></i>-->
<!--        <i class="fa fa-list-ol"></i>-->
<!--        <i class="fa fa-strikethrough"></i>-->
<!--        <i class="fa fa-underline"></i>-->
<!--        <i class="fa fa-table"></i>-->
<!--        <i class="fa fa-magic"></i>-->
<!--        <i class="fa fa-truck"></i>-->
<!--        <i class="fa fa-pinterest"></i>-->
<!--        <i class="fa fa-pinterest-square"></i>-->
<!--        <i class="fa fa-google-plus-square"></i>-->
<!--        <i class="fa fa-google-plus"></i>-->
<!--        <i class="fa fa-money"></i>-->
<!--        <i class="fa fa-caret-down"></i>-->
<!--        <i class="fa fa-caret-up"></i>-->
<!--        <i class="fa fa-caret-left"></i>-->
<!--        <i class="fa fa-caret-right"></i>-->
<!--        <i class="fa fa-columns"></i>-->
<!--        <i class="fa fa-unsorted"></i>-->
<!--        <i class="fa fa-sort-down"></i>-->
<!--        <i class="fa fa-sort-up"></i>-->
<!--        <i class="fa fa-envelope"></i>-->
<!--        <i class="fa fa-linkedin"></i>-->
<!--        <i class="fa fa-rotate-left"></i>-->
<!--        <i class="fa fa-legal"></i>-->
<!--        <i class="fa fa-dashboard"></i>-->
<!--        <i class="fa fa-comment-o"></i>-->
<!--        <i class="fa fa-comments-o"></i>-->
<!--        <i class="fa fa-flash"></i>-->
<!--        <i class="fa fa-sitemap"></i>-->
<!--        <i class="fa fa-umbrella"></i>-->
<!--        <i class="fa fa-paste"></i>-->
<!--        <i class="fa fa-lightbulb-o"></i>-->
<!--        <i class="fa fa-exchange"></i>-->
<!--        <i class="fa fa-cloud-download"></i>-->
<!--        <i class="fa fa-cloud-upload"></i>-->
<!--        <i class="fa fa-user-md"></i>-->
<!--        <i class="fa fa-stethoscope"></i>-->
<!--        <i class="fa fa-suitcase"></i>-->
<!--        <i class="fa fa-bell-o"></i>-->
<!--        <i class="fa fa-coffee"></i>-->
<!--        <i class="fa fa-cutlery"></i>-->
<!--        <i class="fa fa-file-text-o"></i>-->
<!--        <i class="fa fa-building-o"></i>-->
<!--        <i class="fa fa-hospital-o"></i>-->
<!--        <i class="fa fa-ambulance"></i>-->
<!--        <i class="fa fa-medkit"></i>-->
<!--        <i class="fa fa-fighter-jet"></i>-->
<!--        <i class="fa fa-beer"></i>-->
<!--        <i class="fa fa-h-square"></i>-->
<!--        <i class="fa fa-plus-square"></i>-->
<!--        <i class="fa fa-angle-double-left"></i>-->
<!--        <i class="fa fa-angle-double-right"></i>-->
<!--        <i class="fa fa-angle-right"></i>-->
<!--        <i class="fa fa-angle-up"></i>-->
<!--        <i class="fa fa-angle-down"></i>-->
<!--        <i class="fa fa-desktop"></i>-->
<!--        <i class="fa fa-laptop"></i>-->
<!--        <i class="fa fa-tablet"></i>-->
<!--        <i class="fa fa-mobile-phone"></i>-->
<!--        <i class="fa fa-circle-o"></i>-->
<!--        <i class="fa fa-quote-left"></i>-->
<!--        <i class="fa fa-quote-right"></i>-->
<!--        <i class="fa fa-spinner"></i>-->
<!--        <i class="fa fa-circle"></i>-->
<!--        <i class="fa fa-mail-reply"></i>-->
<!--        <i class="fa fa-github-alt"></i>-->
<!--        <i class="fa fa-folder-o"></i>-->
<!--        <i class="fa fa-folder-open-o"></i>-->
<!--        <i class="fa fa-smile-o"></i>-->
<!--        <i class="fa fa-frown-o"></i>-->
<!--        <i class="fa fa-meh-o"></i>-->
<!--        <i class="fa fa-gamepad"></i>-->
<!--        <i class="fa fa-keyboard-o"></i>-->
<!--        <i class="fa fa-flag-o"></i>-->
<!--        <i class="fa fa-flag-checkered"></i>-->
<!--        <i class="fa fa-terminal"></i>-->
<!--        <i class="fa fa-code"></i>-->
<!--        <i class="fa fa-mail-reply-all"></i>-->
<!--        <i class="fa fa-star-half-empty"></i>-->
<!--        <i class="fa fa-location-arrow"></i>-->
<!--        <i class="fa fa-crop"></i>-->
<!--        <i class="fa fa-code-fork"></i>-->
<!--        <i class="fa fa-unlink"></i>-->
<!--        <i class="fa fa-question"></i>-->
<!--        <i class="fa fa-info"></i>-->
<!--        <i class="fa fa-exclamation"></i>-->
<!--        <i class="fa fa-superscript"></i>-->
<!--        <i class="fa fa-subscript"></i>-->
<!--        <i class="fa fa-eraser"></i>-->
<!--        <i class="fa fa-puzzle-piece"></i>-->
<!--        <i class="fa fa-shield"></i>-->
<!--        <i class="fa fa-calendar-o"></i>-->
<!--        <i class="fa fa-fire-extinguisher"></i>-->
<!--        <i class="fa fa-rocket"></i>-->
<!--        <i class="fa fa-maxcdn"></i>-->
<!--        <i class="fa fa-chevron-circle-right"></i>-->
<!--        <i class="fa fa-microchip"></i>-->
<!--        <i class="fa fa-snowflake-o"></i>-->
<!--        <i class="fa fa-superpowers"></i>-->
<!--        <i class="fa fa-wpexplorer"></i>-->
<!--        <i class="fa fa-meetup"></i>-->
<!--        <i class="fa fa-volume-down"></i>-->
<!--        <i class="fa fa-flag"></i>-->
<!--        <i class="fa fa-refresh"></i>-->
<!--        <i class="fa fa-list-alt"></i>-->
<!--        <i class="fa fa-repeat"></i>-->
<!--        <i class="fa fa-inbox"></i>-->
<!--        <i class="fa fa-download"></i>-->
<!--        <i class="fa fa-gear"></i>-->
<!--        <i class="fa fa-signal"></i>-->
<!--        <i class="fa fa-search-plus"></i>-->
<!--        <i class="fa fa-check"></i>-->
<!--        <i class="fa fa-th-list"></i>-->
        <div class="row" style="margin-top: 30px">
          <div class="col-md-4">
            <div class="single-table text-center mb-4 mb-md-0">
              <div class="table-top">
                <h3>无进项票支出</h3>
                <i class="fa fa-money"></i>
              </div>
              <ul class="my-5">
                <li class="mb-2">无票支出</li>
                <li class="mb-2">增值税过高</li>
                <li class="mb-2">企业利润虚高</li>
                <li class="mb-2">财务风险大</li>
              </ul>
            </div>
          </div>
          <div class="col-md-4">
            <div class="single-table text-center mb-4 mb-md-0">
              <div class="table-top">
                <h3>合作风险</h3>
                <i class="fa fa-lightbulb-o"></i>
              </div>
              <ul class="my-5">
                <li class="mb-2">劳务纠纷多</li>
                <li class="mb-2">用工合规难</li>
                <li class="mb-2">小微合作伙伴税务不规范</li>
                <li class="mb-2">增加企业自身税务成本和风险</li>
              </ul>
            </div>
          </div>
          <div class="col-md-4">
            <div class="single-table text-center">
              <div class="table-top">
                <h3>管理成本高</h3>
                <i class="fa fa-group"></i>
              </div>
              <ul class="my-5">
                <li class="mb-2">个税成本高</li>
                <li class="mb-2">申报个税流程繁琐</li>
                <li class="mb-2">个人信息管理核验难</li>
                <li class="mb-2">人员管理投入成本大</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Pricing Table End -->


    <!-- Contact Form Starts -->
    <section class="contact-form section-padding3">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <h2>我们为您免费提供解决方案</h2>
              <!--              <p>gormless cheeky bugger he nicked it golly gosh a arse show off show off</p>-->
            </div>
          </div>
        </div>
        <div class="row">
<!--          <div class="col-lg-3 mb-5 mb-lg-0">-->
<!--            <div class="d-flex">-->
<!--              <div class="into-icon">-->
<!--                <i class="fa fa-home"></i>-->
<!--              </div>-->
<!--              <div class="info-text">-->
<!--                <h4>北京市昌平区西三旗街道新龙大厦B座725</h4>-->
<!--                <p>Santa monica bullevard</p>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="d-flex">-->
<!--              <div class="into-icon">-->
<!--                <i class="fa fa-phone"></i>-->
<!--              </div>-->
<!--              <div class="info-text">-->
<!--                <h4>//todo公司电话</h4>-->
<!--                <p>Mon to Fri 9am to 6 pm</p>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="d-flex">-->
<!--              <div class="into-icon">-->
<!--                <i class="fa fa-envelope-o"></i>-->
<!--              </div>-->
<!--              <div class="info-text">-->
<!--                <h4>//todo公司邮箱</h4>-->
<!--                <p>Send us your query anytime!</p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
          <div class="col-lg-10 offset-lg-1">
            <el-form>
              <div class="left">
                <el-input v-model="name" maxlength="32" type="text" placeholder="请输入您的姓名"/>
                <el-input v-model="email" maxlength="128" type="email" placeholder="请输入您的邮箱"/>
                <el-input v-model="phone" oninput="if(value.length>11)value=value.slice(0,11)"
                          onkeyup="this.value = this.value.replace(/[^\d]/g,'');" placeholder="请输入您的手机号"/>
              </div>
              <div class="right">
                <el-input type="textarea" maxlength="500" v-model="message" cols="20" rows="7" placeholder="详细留言"></el-input>
              </div>
              <button @click="submit" class="template-btn">提交留言</button>
            </el-form>
          </div>
        </div>
      </div>
    </section>
    <!-- Contact Form End -->
  </div>
</template>
<script>

  export default {
    data () {
      return {
        name: null,
        email: null,
        phone: null,
        message: null
      }
    },
    methods: {
      submit: function (event) {
        console.log(this.name)
        console.log(this.email)
        console.log(this.phone)
        console.log(this.message)
        if (this.name == null || this.name === '') {
          this.msgError('姓名不能为空')
          return false
        }
        if (this.name.length > 32) {
          this.msgError('姓名不能过长')
          return false
        }
        if ((this.email == null || this.email === '') && (this.phone == null || this.phone === '')) {
          this.msgError('邮箱和手机号，至少填写一个')
          return false
        }
        if (this.email != null && this.email !== '') {
          if (!/^(\w)+(.?\w*)*@[\da-z.-]+.([a-z]{2,6}|[\u2E80-\u9FFF]{2,3})$/.test(this.email)) {
            this.msgError('邮箱格式有误')
            return false
          }
        }
        if (this.phone != null && this.phone !== '') {
          if (!/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(this.phone)) {
            this.msgError('手机号格式有误')
            return false
          }
        }
        if (this.message == null || this.message === '') {
          this.msgError('详细信息不能为空')
          return false
        }
        if (this.message.length > 500) {
          this.msgError('详细信息不能过长')
          return false
        }
        this.$http({
          method: 'POST',
          // url: 'https://selfapi.bjdianxing.com/app/person/menhuData',
          url: 'https://localhost:8084/app/person/menhuData',
          data: {'name': this.name, 'email': this.email, 'phone': this.phone, 'message': this.message},
          headers: {'X-Requested-With': 'XMLHttpRequest'}
        }).then((res) => {
          this.msgSuccess('提交成功')
          this.name = null
          this.email = null
          this.phone = null
          this.message = null
        }).catch((err) => {
          console.log(err)
          this.msgError('提交失败,请稍后重试')
        })
        // submitMenhu(this.form).then(response => {
        //   this.msgSuccess('提交成功')
        //   this.name = null
        //   this.email = null
        //   this.phone = null
        //   this.message = null
        // })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/pages/ContactUs.vue